<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <!-- <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <v-btn color="blue darken-2" rounded dark small depressed>
                <v-icon left>mdi-plus-circle</v-icon>Adicionar Colaborador
              </v-btn>
            </v-col>
          </v-row>-->
          <v-form ref="formBusca">
            <v-row dense>
              <v-col cols="12" sm="12" md="3">
                <SelectEmpresa
                  :multiple="true"
                  @onChanged="filtro.empresas = $event"
                  @onEmpresas="dat = $event"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select label="Ativa" v-model="filtro.ativo" :items="['Sim', 'Não']"></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            v-model="table.selected"
            :headers="table.headers"
            :items="table.dados"
            :search="table.search"
            group-by="nomeEmpresa"
            sort-by="nome"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="table.search"
                    label="Procurar..."
                    prepend-inner-icon="mdi-magnify"
                  />
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.ativo="{ item }">
              <v-btn v-if="$ability.can('Editar','Colaboradores')" color="transparent" small fab depressed @click="alterar_status(item)">
                <v-icon
                  :color="item.ativo ? 'green' : 'red'"
                  :title="item.ativo ? 'Ativa' : 'Desativada'"
                >
                  {{
                  item.ativo ? 'mdi-check' : 'mdi-close'
                  }}
                </v-icon>
              </v-btn>
              <v-btn v-else color="transparent" small fab depressed>
                <v-icon
                  :color="item.ativo ? 'green' : 'red'"
                  :title="item.ativo ? 'Ativa' : 'Desativada'"
                >
                  {{
                  item.ativo ? 'mdi-check' : 'mdi-close'
                  }}
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:group.header="{ items }">
              <td colspan="10" class="text-start">
                <v-icon color="blue darken-1" small>mdi-arrow-right-drop-circle</v-icon>
                {{ items[0].nomeEmpresa }}
              </td>
            </template>

            <template v-slot:item.action="{ item }">
              <v-tooltip v-if="$ability.can('Editar','Colaboradores')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    fab
                    v-on="on"
                    depressed
                    @click="$refs.dialogCol.show(true, item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                Editar Colaborador
              </v-tooltip>

              <v-tooltip v-if="$ability.can('Vincular Colaborador/Empresa','Colaboradores')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    fab
                    v-on="on"
                    depressed
                    @click="$refs.dialogVincular.show(true, item)"
                  >
                    <v-icon>mdi-link-variant</v-icon>
                  </v-btn>
                </template>
                Vincular Colaborador a Empresas
              </v-tooltip>
            </template>
            <template v-slot:item.cpf="{ item }">
              <span>{{ getFormartCpf(item.cpf) }}</span>
            </template>
            <!-- <template v-slot:item.telefone="{ item }">
              <span>{{ getFormartTelefone(item.telefone) }}</span>
            </template>-->
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <DialogVincular ref="dialogVincular" />

    <DialogColaborador saved="buscar" ref="dialogCol" />
  </v-row>
</template>

<script>
import Colaborador from "@/services/colaborador";
import rules from "@/utils/rules";

export default {
  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogColaborador: () => import("./components/DialogColaborador"),
    DialogVincular: () => import("./components/DialogVincular")
  },
  data() {
    return {
      dat: [],
      rules: rules,
      filtro: {
        ativo: "Sim",
        empresas: []
      },

      empresas: [],
      table: {
        selected: [],
        search: "",
        headers: [
          { text: "Nome", value: "nome" },
          { text: "CPF", value: "cpf" },
          // { text: "Email", value: "email" },
          { text: "Função", value: "funcao" },
          { text: "Departamento", value: "departamento" },
          { text: "Ativo", value: "ativo" },
          { text: "Actions", value: "action" }
        ],
        dados: []
      }
    };
  },
  methods: {
    getFormartCpf(valor) {
      return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    },
    getFormartTelefone(item) {
      return item.replace(/(\d{2})(\d{5})(\d{4})/g, "($1)$2-$3");
    },
    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          //const dados = await new Colaborador().getAll()
          const dados = await new Colaborador().listAll(this.filtro, this.dat);

          this.table.dados = dados;
          if (dados.length === 0) {
            this.$toast.warning("Nada foi encontrado");
          }
        } catch (error) {
          this.$toast.error(error);
        }
      }
    },
    alterar_status(item) {
      if (item.ativo) {
        this.$swal.confirm("Vc deseja desativar colaborador?").then(() => {
          this.update(item, false);
        });
      } else {
        this.$swal.confirm("Vc deseja ativar colaborador? ").then(() => {
          this.update(item, true);
        });
      }
    },
    async update(item, value) {
      try {
        const dados = await new Colaborador().updateAtivo(item.id, value);
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.buscar();
      }
    }
  }
};
</script>

<style></style>
